// extracted by mini-css-extract-plugin
module.exports = {"btn":"ARButton_btn__2pxAc"};